import { Tooltip, Modal } from "./_bootstrap";
// import "./_category";

$(document).ready(function () {
  if (typeof lozad !== "undefined") {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
    $(document).ajaxStop(function () {
      observer.observe();
    });
  }

  // Highlight any found errors
  $(".text-danger").each(function () {
    var element = $(this).parent().parent();

    if (element.hasClass("form-group")) {
      element.addClass("has-error");
    }
  });

  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function () {
    document.querySelectorAll('[data-toggle="tooltip"]').forEach((el) => {
      const t = Tooltip.getInstance(el);
      if (t) {
        t.dispose();
      }
    });
    document
      .querySelectorAll('[data-toggle="tooltip"]')
      .forEach((tooltipElement) => new Tooltip(tooltipElement));
  });

  $(document)
    .on("click", '[data-action="fastOrder"]', loadFastOrderForm)
    .on("click", '[data-action="showCart"]', initCart)
    .on("click", '[data-action="toCart"]', function () {
      const productId = $(this).data("id");
      cart.add(productId, 1);
    })
    .on("click", '[data-action="showLoginForm"]', function (e) {
      e.preventDefault();
      openLoginForm();
    })
    .on("click", '[data-action="showNavigation"]', function (e) {
      e.preventDefault();
      openMenuMobile();
    })
    .on("click", '[data-action="showSerchForm"]', function () {
      $("body").toggleClass("showSerach");
    })
    .on("click", '[data-action="hideSerchForm"]', function () {
      $("body").removeClass("showSerach");
    })
    .on("click", function (e) {
      if (
        !$(e.target).closest(".top-serach-container").length &&
        $(e.target).closest('[data-action="showSerchForm"]').length == 0
      ) {
        $("body").removeClass("showSerach");
      }
    });

  var toTop = $("#toTop");

  $(window).scroll(function () {
    var $this = $(this);
    $this.scrollTop() > 200
      ? toTop.addClass("visible")
      : toTop.removeClass("visible");
  });

  toTop.click(function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  const menuDropdown = document.getElementById("menuDropdown");
  menuDropdown.addEventListener("show.bs.dropdown", () => {
    $("body").append('<div class="overlay fade"></div>');
    setTimeout(() => {
      $(".overlay").addClass("show");
    }, 1);
  });
  menuDropdown.addEventListener("hidden.bs.dropdown", () => {
    $(".overlay").remove();
  });
});

function loadFastOrderForm() {
  if ($("#modalFastOrderForm").length > 0) {
    $("#modalFastOrderForm").remove();
  }
  if ($(this).data("productId")) {
    $.get(
      "index.php?route=product/fast_order",
      { order_product_id: $(this).data("productId") },
      function (data) {
        $("body").append(data);
        setTimeout(function () {
          $("#modalFastOrderForm").modal("show");
        }, 100);
      },
    );
  }
}

function initCart() {
  if ($("#modalHeaderCart").length < 1) {
    $.get("index.php?route=common/cart/info", function (data) {
      $("body").append(data);
      setTimeout(function () {
        $("#modalHeaderCart").modal("show");
      }, 1);
    });
  } else {
    $("#modalHeaderCart").modal("show");
  }
}
window.initCart = initCart;

function openLoginForm() {
  if ($("#loginFormModal").length < 1) {
    $.get("index.php?route=account/login/getForm", function (data) {
      $("body").append(data);
      setTimeout(function () {
        $("#loginFormModal").modal("show");
      }, 100);
    });
  } else {
    $("#loginFormModal").modal("show");
  }
}

function openMenuMobile() {
  if ($("#showMenuMobile").length < 1) {
    $.get("index.php?route=common/menu_mobile", function (data) {
      $("body").append(data);
      setTimeout(function () {
        const $menuLanguageSection = $(document).find('#showMenuMobile .s-mMenu');

        if (!$menuLanguageSection.find('[data-language-section]').length) {
          $menuLanguageSection.addClass('position-relative');
          $('.s-header__bottom')
            .find('[data-language-section]')
            .first()
            .clone()
            .removeClass('d-none px-0')
            .addClass('position-absolute end-0 top-0 p-3 z-3')
            .prependTo($menuLanguageSection);
        }
        $("#showMenuMobile").offcanvas("show");
      }, 100);
    });
  } else {
    $("#showMenuMobile").offcanvas("show");
  }
}

$(document)
  .on("click", ".qty-minus", function () {
    var $input = $(this).closest(".js-quantity").find("input");
    var min = $input.data("min") ?? 1;
    var count = parseInt($input.val()) - 1;
    count = count < min ? min : count;
    $input.val(count);
    $input.change();
    return false;
  })
  .on("click", ".qty-plus", function () {
    var $input = $(this).closest(".js-quantity").find("input");
    var min = 1; // $input.data("min") ?? 1;
    $input.val(parseInt($input.val()) + min);
    $input.change();
    return false;
  })
  .on("keyup", ".qty-input", function () {
    var $input = $(this);
    var min = 1; // $input.data("min") ?? 1;
    var $inputVal = parseInt($input.val());
    $input.val($inputVal > 0 ? $inputVal : min);
    return false;
  })
  .on("change", ".qty-input", function () {
    var $input = $(this);
    var min = $input.data("min") ?? 1;
    var count = parseInt($input.val());
    var btnMinus = $input.closest(".js-quantity").find(".qty-minus");
    if (count > min) {
      btnMinus.prop("disabled", false);
    } else {
      btnMinus.prop("disabled", true);
    }
    if (
      typeof $input.attr("data-cart-id") !== "undefined" &&
      $input.attr("data-cart-id")
    ) {
      cart.update($input.attr("data-cart-id"), count);
    }
  });

window.Modal = Modal;

// Cart add remove functions
var cart = {
  change: function (el, key) {
    let min = 1,
      qtyEl = $(el),
      qtyVal = parseInt(qtyEl.val().match(/\d+/g), 10);

    qtyVal = qtyVal > min && !Number.isNaN(qtyVal) ? qtyVal : min;

    this.update(key, qtyVal);
  },
  plus: function (el, key) {
    let min = 1,
      qtyEl = $(el).closest(".cart-quantity").find('input[name^="quantity"]'),
      qtyVal = parseInt(qtyEl.val().match(/\d+/g), 10);

    qtyVal = !Number.isNaN(qtyVal) ? ++qtyVal : min;

    this.update(key, qtyVal);
  },
  minus: function (el, key) {
    let min = 1,
      qtyEl = $(el).closest(".cart-quantity").find('input[name^="quantity"]'),
      qtyVal = parseInt(qtyEl.val().match(/\d+/g), 10);

    qtyVal = qtyVal > min && !Number.isNaN(qtyVal) ? --qtyVal : min;

    this.update(key, qtyVal);
  },
  add: function (product_id, quantity) {
    $.ajax({
      url: "index.php?route=checkout/cart/add",
      type: "post",
      data:
        "product_id=" +
        product_id +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible, .text-danger").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        if (json["success"]) {
          // Need to set timeout otherwise it wont update the total
          setTimeout(function () {
            $(".js-headerCartIcon")
              .html(json["total"])
              .addClass("s-header__active");
          }, 100);

          $.get("index.php?route=common/cart/info", function (data) {
            initCart();
            $(".popupCartContent").html(
              $(data).find(".popupCartContent").html(),
            );

            // const modalHeaderCart = new Modal("#modalHeaderCart", {});
            // modalHeaderCart.show();
          });
        }
      },
    });
  },
  update: function (key, quantity) {
    $.ajax({
      url: "index.php?route=checkout/cart/edit",
      type: "post",
      data:
        "key=" +
        key +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      success: function (json) {
        // Need to set timeout otherwise it wont update the total
        setTimeout(function () {
          $(".js-headerCartIcon").html(json["total"]);
        }, 100);

        $.get("index.php?route=common/cart/info", function (data) {
          $(".popupCartContent").html($(data).find(".popupCartContent").html());
        });
      },
    });
  },
  remove: function (key) {
    $.ajax({
      url: "index.php?route=checkout/cart/remove",
      type: "post",
      data: "key=" + key,
      dataType: "json",
      success: function (json) {
        // Need to set timeout otherwise it wont update the total
        setTimeout(function () {
          $(".js-headerCartIcon").html(json["total"]);
          if (json["total"] < 1) {
            $(".js-headerCartIcon").removeClass("s-header__active");
          }
        }, 100);

        $.get("index.php?route=common/cart/info", function (data) {
          $(".popupCartContent").html($(data).find(".popupCartContent").html());
        });
      },
    });
  },
};

window.cart = cart;

var wishlist = {
  add: function (product_id) {
    // if (globalConfig.Customer.isLogged) {
    $.ajax({
      url: "index.php?route=account/wishlist/add",
      type: "post",
      data: "product_id=" + product_id,
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        if (json["success"]) {
          toastr.success(json["success"]);
        }

        $("#wishlist-total span").html(json["total"]);
        $("#wishlist-total").attr("title", json["total"]);
      },
    });
    // } else {
    //   openLoginForm();
    // }
  },
  remove: function () {},
};

window.wishlist = wishlist;

var compare = {
  add: function (product_id) {
    $.ajax({
      url: "index.php?route=product/compare/add",
      type: "post",
      data: "product_id=" + product_id,
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible").remove();

        if (json["success"]) {
          toastr.success(json["success"]);
          $("#compare-total").addClass("s-header__active");
          $("#compare-total span").html(json["total"]);
        }
      },
    });
  },
  remove: function () {},
};

window.compare = compare;

// Autocomplete */
(function ($) {
  $.fn.autocomplete = function (option) {
    return this.each(function () {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      $(this).attr("autocomplete", "off");

      // Focus
      $(this).on("focus", function () {
        this.request();
      });

      // Blur
      $(this).on("blur", function () {
        setTimeout(
          function (object) {
            object.hide();
          },
          200,
          this,
        );
      });

      // Keydown
      $(this).on("keydown", function (event) {
        switch (event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

      // Click
      this.click = function (event) {
        event.preventDefault();

        var value = $(event.target).closest("li").attr("data-value");

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      };

      // Show
      this.show = function () {
        var pos = $(this).position();

        $(this)
          .siblings("ul.dropdown-menu")
          .css({
            top: pos.top + $(this).outerHeight(),
            left: pos.left,
          });

        $(this).siblings("ul.dropdown-menu").show();
      };

      // Hide
      this.hide = function () {
        $(this).siblings("ul.dropdown-menu").hide();
      };

      // Request
      this.request = function () {
        clearTimeout(this.timer);

        this.timer = setTimeout(
          function (object) {
            object.source($(object).val(), $.proxy(object.response, object));
          },
          200,
          this,
        );
      };

      // Response
      this.response = function (json) {
        let html = "";

        if (json.length) {
          for (let i = 0; i < json.length; i++) {
            this.items[json[i]["value"]] = json[i];
          }

          for (let i = 0; i < json.length; i++) {
            if (!json[i]["category"]) {
              html +=
                '<li data-value="' +
                json[i]["value"] +
                '"><a href="#">' +
                json[i]["label"] +
                "</a></li>";
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (let i = 0; i < json.length; i++) {
            if (json[i]["category"]) {
              if (!category[json[i]["category"]]) {
                category[json[i]["category"]] = new Array();
                category[json[i]["category"]]["name"] = json[i]["category"];
                category[json[i]["category"]]["item"] = new Array();
              }

              category[json[i]["category"]]["item"].push(json[i]);
            }
          }

          for (let i in category) {
            html +=
              '<li class="dropdown-header">' + category[i]["name"] + "</li>";

            for (j = 0; j < category[i]["item"].length; j++) {
              html +=
                '<li data-value="' +
                category[i]["item"][j]["value"] +
                '"><a href="#">&nbsp;&nbsp;&nbsp;' +
                category[i]["item"][j]["label"] +
                "</a></li>";
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        $(this).siblings("ul.dropdown-menu").html(html);
      };

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this)
        .siblings("ul.dropdown-menu")
        .delegate("a", "click", $.proxy(this.click, this));
    });
  };
})(window.jQuery);

(function () {
  const slider = document.querySelector(".js-sliderCol");
  const menu = document.querySelector(".js-containerMenu");

  if (!slider || !menu || !(slider.children.length > 0)) return;

  // 👉 клас якщо є слайдер
  menu.classList.add("always-open");

  let raf = null;

  function update() {
    raf = null;

    const h = slider.getBoundingClientRect().height;
    if (h > 0) {
      menu.style.height = h + "px";
    }
  }

  function requestUpdate() {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  // базові тригери
  window.addEventListener("load", requestUpdate);
  window.addEventListener("resize", requestUpdate);

  // якщо слайдер змінює розмір
  if ("ResizeObserver" in window) {
    new ResizeObserver(requestUpdate).observe(slider);
  }
})();
